/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'Survey' store object.
 * @namespace SurveySelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UASurvey';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SurveySelectors
   */
  static fetchSurveyQuestions = state =>
    state[selectors.moduleIdentifier].fetchSurveyQuestions.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SurveySelectors
   */
  static isFetchingFetchSurveyQuestions = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSurveyQuestions.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SurveySelectors
   */
  static fetchSurveyQuestionsError = state =>
    state[selectors.moduleIdentifier].fetchSurveyQuestionsError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SurveySelectors
   */
  static postSurveyAnswers = state => state[selectors.moduleIdentifier].postSurveyAnswers.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SurveySelectors
   */
  static isFetchingPostSurveyAnswers = state =>
    state[selectors.moduleIdentifier].isFetchingPostSurveyAnswers.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SurveySelectors
   */
  static postSurveyAnswersError = state =>
    state[selectors.moduleIdentifier].postSurveyAnswersError.payload;
}
